import moment from 'moment';
import React from 'react';

const DemoRequestsTable = ({
    rows,
    loading,
    paginationData,
    paginationState,
    setPaginationState,
    onChangeStatus,
}: {
    rows?: any;
    loading?: boolean;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any;
    onChangeStatus: (id: string, status: string) => void;
}) => {

    return (
        <div className=''>
            <div className='overflow-x-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-darkMode min-h-[200px]'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-darkMode rounded-xl'>
                        <tr>
                            {/* <th className='px-4 py-3'>ID</th> */}
                            <th className='px-4 py-3'>Name</th>
                            <th className='px-4 py-3'>Email</th>
                            <th className='px-4 py-3'>Company Name</th>
                            <th className='px-4 py-3'>Business Type</th>
                            <th className='px-4 py-3'>Address</th>
                            <th className='px-4 py-3'>AI Agent</th>
                            <th className='px-4 py-3'>Created Date</th>
                            <th className='px-4 py-3'>Invited By</th>
                            <th className='px-4 py-3'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading &&
                            Array.from({ length: 5 }).map((_, i) => (
                                <tr key={`skeleton-${i}`} className='animate-pulse'>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/3'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                    <td className='px-4 py-4'>
                                        <div className='h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2'></div>
                                    </td>
                                </tr>
                            ))}
                        {!loading && (!rows || rows.length === 0) && (
                            <tr>
                                <td colSpan={7} className='px-4 py-6 text-center text-gray-500 dark:text-primary-dark'>
                                    No data currently available
                                </td>
                            </tr>
                        )}
                        {(!loading && rows?.length > 0) && rows?.map((row: any, idx: any) => {
                            const worker =
                                row?.worker
                                    ? row.worker[0].toUpperCase() + row.worker.slice(1).toLowerCase()
                                    : row?.worker; return (
                                        <tr key={row._id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                            <td className={`px-4 py-4`}>{row?.name || '--'}</td>
                                            <td className={`px-4 py-4`}>{row?.email}</td>
                                            <td className={`px-4 py-4`}>{row?.companyName || '--'}</td>
                                            <td className={`px-4 py-4`}>{row?.businessType || '--'}</td>
                                            <td className={`px-4 py-4`}>{row?.address || '--'}</td>
                                            <td className={`px-4 py-4`}>{worker ? `${worker} AI Agent` : '--'}</td>
                                            <td className={`px-4 py-4`}>{moment(row?.createdAt).format('DD/MM/YYYY hh:mm A')}</td>
                                            <td className={`px-4 py-4`}>{row?.invitedBy?.source ? row?.invitedBy?.source === 'AM_DASHBOARD' ? 'AM Dashboard' : row?.invitedBy?.username : 'Hotelworld AI'}</td>
                                            <td className={`px-4 py-4`}>
                                                {row?.status ?
                                                    <p className={`${row?.status === 'ACCEPTED' ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>{row?.status === 'ACCEPTED' ? 'Accepted' : 'Rejected'}</p>
                                                    : <div className='flex flex-row items-center'>
                                                        <div
                                                            onClick={() => onChangeStatus(row?._id || '', 'ACCEPTED')}
                                                            className='mr-3 bg-[#f3fbf9] dark:bg-bgColor-darkMode p-2 rounded flex flex-row items-center cursor-pointer hover:opacity-80'>
                                                            <img src={'/assets/shared/accept.svg'} className='object-contain w-[18px]' />
                                                            <p className='ml-2 mr-2 text-[#10B981]'>Accept</p>
                                                        </div>
                                                        <div
                                                            onClick={() => onChangeStatus(row?._id, 'REJECTED')}
                                                            className='mr-3 bg-[#f3fbf9] dark:bg-bgColor-darkMode p-2 rounded flex flex-row items-center cursor-pointer hover:opacity-80'>
                                                            <img src={'/assets/shared/reject.svg'} className='object-contain w-[18px]' />
                                                            <p className='ml-2 mr-2 text-[#EF4444]'>Reject</p>
                                                        </div>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    )
                        })
                        }
                    </tbody>
                </table>
            </div>
            {paginationData &&
                (() => {
                    const currentPage = paginationData.number;
                    const totalPages = paginationData.totalPages;

                    const getPageList = () => {
                        const pageList: (number | string)[] = [];

                        if (totalPages <= 7) {
                            for (let i = 1; i <= totalPages; i++) {
                                pageList.push(i);
                            }
                        } else {
                            pageList.push(1);

                            if (currentPage > 3) {
                                pageList.push('...');
                            }

                            const start = Math.max(2, currentPage - 1);
                            const end = Math.min(totalPages - 1, currentPage + 1);

                            for (let i = start; i <= end; i++) {
                                pageList.push(i);
                            }

                            if (currentPage < totalPages - 2) {
                                pageList.push('...');
                            }

                            pageList.push(totalPages);
                        }

                        return pageList;
                    };

                    return (
                        <div className='flex justify-between items-center text-sm text-[#8F8F8F] dark:text-primary-darkMode px-5 py-2 mt-1 border-t border-[#DCDCDD]'>
                            {/* <div>
                                {paginationData.totalElements > 0 && (
                                    <span>
                                        {1 + ((currentPage - 1) * paginationData.size)}–
                                        {Math.min(currentPage * paginationData.size, paginationData.totalElements)} of {paginationData.totalElements} items
                                    </span>
                                )}
                            </div> */}
                            <div className='flex items-center gap-2'>
                                <button
                                    disabled={currentPage <= 1}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage - 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ◀
                                </button>

                                {getPageList().map((item, idx) => {
                                    if (typeof item === 'string') {
                                        return <span key={idx} className='px-2'>...</span>;
                                    }
                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => setPaginationState?.({ ...paginationState, pageNumber: item })}
                                            className={`px-3 py-1 rounded transition-colors duration-200 ${item === currentPage ? 'bg-gray-400 text-white dark:bg-white dark:text-black' : 'hover:bg-gray-300 dark:hover:bg-black'}`}
                                        >
                                            {item}
                                        </button>
                                    );
                                })}

                                <button
                                    disabled={!paginationData?.hasNextPage}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage + 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    );
                })()
            }
        </div>
    );
};

export default DemoRequestsTable;